<script lang="ts">
    import type {LocalizeFunction} from '../../svelte/types';
    import {getContext} from 'svelte';
    import {LOCALIZE_KEY} from '../../svelte/utils';
    import type {RecordCollectionManager} from '../../record-collections/record-collection-manager';
    import type {RecordCollectionViewConfiguration} from '../../typings/portaro.fe.types';
    import KpRecordCollection from '../../record-collections/kp-record-collection/KpRecordCollection.svelte';
    import KpVisitedPanel from '../../commons/components/kp-visited-panel/KpVisitedPanel.svelte';
    import KpPluralizeText from '../../commons/components/kp-pluralize-text/KpPluralizeText.svelte';

    export let recordCollectionManager: RecordCollectionManager;
    export let viewConfiguration: RecordCollectionViewConfiguration;

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);

    let collectionSize = recordCollectionManager.getSize();

    function updateCollectionSize() {
        collectionSize = recordCollectionManager.getSize();
    }
</script>

<template>
    <div class="row">
        <h1 class="col-sm-12">{localize(/* @kp-localization recordCollections.favourites.Favourites */ 'recordCollections.favourites.Favourites')}</h1>
    </div>

    <div class="row">
        <div class="col-sm-8 main-panel-hlavni">

            <div class="record-collection-size">
                <span class="collection-size-counter">
                    <KpPluralizeText
                            count={collectionSize}
                            zeroCountText={localize(/* @kp-localization recordCollections.favourites.vOblibenychNejsouZadneZaznamy */ 'recordCollections.favourites.vOblibenychNejsouZadneZaznamy')}
                            oneCountText={localize(/* @kp-localization recordCollections.favourites.1ZaznamVOblibenych */ 'recordCollections.favourites.1ZaznamVOblibenych')}
                            twoThreeFourCountText={localize(/* @kp-localization recordCollections.favourites.xZaznamyVOblibenych */ 'recordCollections.favourites.xZaznamyVOblibenych')}
                            moreText={localize(/* @kp-localization recordCollections.favourites.xZaznamuVOblibenych */ 'recordCollections.favourites.xZaznamuVOblibenych')}/>
                </span>
            </div>

            <KpRecordCollection {recordCollectionManager} {viewConfiguration} on:update={updateCollectionSize}/>
        </div>

        <!-- pravy sloupec -->
        <aside class="col-sm-4 main-panel-pravy">
            <KpVisitedPanel/>
        </aside>
    </div>
</template>